// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "proto/common/transaction.proto" (package "proto.common", syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "proto/common/transaction.proto" (package "proto.common", syntax proto3)
// tslint:disable

/**
 * @generated from protobuf enum proto.common.TransactionCategory
 */
export var TransactionCategory;

(function (TransactionCategory) {
  /**
   * неторговые категории
   *
   * Прочее
   *
   * @generated from protobuf enum value: OTHERS = 0;
   */
  TransactionCategory[TransactionCategory["OTHERS"] = 0] = "OTHERS";
  /**
   * Ввод ДС
   *
   * @generated from protobuf enum value: DEPOSIT = 1;
   */

  TransactionCategory[TransactionCategory["DEPOSIT"] = 1] = "DEPOSIT";
  /**
   * Вывод ДС
   *
   * @generated from protobuf enum value: WITHDRAW = 2;
   */

  TransactionCategory[TransactionCategory["WITHDRAW"] = 2] = "WITHDRAW";
  /**
   * Доход
   *
   * @generated from protobuf enum value: INCOME = 5;
   */

  TransactionCategory[TransactionCategory["INCOME"] = 5] = "INCOME";
  /**
   * Комиссии
   *
   * @generated from protobuf enum value: COMMISSION = 7;
   */

  TransactionCategory[TransactionCategory["COMMISSION"] = 7] = "COMMISSION";
  /**
   * Налог	Налог
   *
   * @generated from protobuf enum value: TAX = 8;
   */

  TransactionCategory[TransactionCategory["TAX"] = 8] = "TAX";
  /**
   * Наследство
   *
   * @generated from protobuf enum value: INHERITANCE = 9;
   */

  TransactionCategory[TransactionCategory["INHERITANCE"] = 9] = "INHERITANCE";
  /**
   * Перевод ДС
   *
   * @generated from protobuf enum value: TRANSFER = 11;
   */

  TransactionCategory[TransactionCategory["TRANSFER"] = 11] = "TRANSFER";
  /**
   * Расторжение договора
   *
   * @generated from protobuf enum value: CONTRACT_TERMINATION = 12;
   */

  TransactionCategory[TransactionCategory["CONTRACT_TERMINATION"] = 12] = "CONTRACT_TERMINATION";
  /**
   * Расходы
   *
   * @generated from protobuf enum value: OUTCOMES = 13;
   */

  TransactionCategory[TransactionCategory["OUTCOMES"] = 13] = "OUTCOMES";
  /**
   * Штраф
   *
   * @generated from protobuf enum value: FINE = 15;
   */

  TransactionCategory[TransactionCategory["FINE"] = 15] = "FINE";
  /**
   * Займ
   *
   * @generated from protobuf enum value: LOAN = 19;
   */

  TransactionCategory[TransactionCategory["LOAN"] = 19] = "LOAN";
  /**
   * торговые категории
   *
   * Покупка актива
   *
   * @generated from protobuf enum value: ASSET_BUY = 16;
   */

  TransactionCategory[TransactionCategory["ASSET_BUY"] = 16] = "ASSET_BUY";
  /**
   * Продажа актива
   *
   * @generated from protobuf enum value: ASSET_SELL = 17;
   */

  TransactionCategory[TransactionCategory["ASSET_SELL"] = 17] = "ASSET_SELL";
})(TransactionCategory || (TransactionCategory = {}));